import { useState } from 'react';
import loadable from '@loadable/component';

import type { Holding } from '@/hooks/portfolio/usePortfolio';
import { NarrativeFairValue } from '@/components/NarrativeFairValue';

import { useReduxStateForPortfolio } from '../../hooks/useReduxStateForPortfolio';

const NarrativeFairValueModal = loadable(
  () => import('@/components/NarrativeFairValue'),
  { resolveComponent: (c) => c.NarrativeFairValueModal }
);

export interface Props {
  holding: Holding;
}

const PortfolioNarrativeFairValue = ({ holding }: Props) => {
  const { portfolioId } = useReduxStateForPortfolio();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { narrativeFairValue, company } = holding;

  if (
    typeof narrativeFairValue !== 'undefined' &&
    typeof portfolioId !== 'undefined'
  ) {
    return (
      <>
        <NarrativeFairValueModal
          portfolioId={portfolioId}
          companyName={company.name}
          isModalOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          uniqueSymbol={company.tickerSymbol}
          companyId={company.id}
          priceTargetAnalystCount={
            company.analysisValue.priceTargetAnalystCount ?? 0
          }
          defaultUserFairValue={
            narrativeFairValue.valuationId !== null
              ? narrativeFairValue.fairValue
              : null
          }
          existingValuationType={
            narrativeFairValue.valuationId !== null
              ? narrativeFairValue.type
              : null
          }
          companyCurrencyISO={
            company.data.currencyInfo.trading_item_currency_iso
          }
          npvPerShare={company.analysisValue.npvPerShare}
          priceTarget={company.analysisValue.priceTarget}
          currentPrice={company.analysisValue.lastSharePrice}
          valuationId={narrativeFairValue.valuationId}
          narrativeId={narrativeFairValue.narrativeId}
          isExistingNarrative={
            narrativeFairValue.narrativeId !== null &&
            narrativeFairValue.narrativeId !== ''
          }
          contentHtml={narrativeFairValue.contentHtml}
        />
        <NarrativeFairValue
          currencyISO={company.data.currencyInfo.trading_item_currency_iso}
          onClick={() => setIsModalOpen(true)}
          narrativeFairValue={narrativeFairValue}
          npvPerShare={company.analysisValue.npvPerShare}
        />
      </>
    );
  }

  return null;
};

export default PortfolioNarrativeFairValue;
